<p>add-funds works!</p>
